import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const updateShopCap = async (paymentToken: string, chargeId: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shopify/payments/set-payment-inner',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            token: paymentToken,
            chargeId
        },
        isEncrypted: true,
    });
}